import { makeRequestCreator } from './common.js'
import store from '@/store'

const CharacterAPI = {
  /**
   * 게임 캐릭터 목록 조회
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getCharacterList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getCharacterList',
      {
        method: 'get',
        url: `/user/character/list/${store.getters['main/shopSeq']}?pageNo=${
          params.pageNo
        }&pageSize=${params.pageSize}&sortType=${params.sortType}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 게임 캐릭터 설정 조회
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getSelectedCharacter: (
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getSelectedCharacter',
      {
        method: 'get',
        url: `/user/character/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 게임 캐릭터 설정
   * @param {String} gid - Game Service ID
   * @param {String} worldId - 게임 내 월드 식별자
   * @param {String} worldName - 게임 내 월드 이름
   * @param {String} gcid - 게임 내 캐릭터 식별자
   * @param {String} gcName - 게임 내 캐릭터 이름
   * @param {String} gcClass - 게임 내 캐릭터 직업
   */
  setCharacter: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'setCharacter',
      {
        method: 'post',
        url: `/user/character/${store.getters['main/shopSeq']}`,
        data: {
          shopSeq: store.getters['main/shopSeq'],
          gid: params.gid,
          worldId: params.worldId,
          worldName: params.worldName,
          gcid: params.gcid,
          gcName: params.gcName,
          gcLevel: params.gcLevel,
          gcClass: params.gcClass
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 게임 캐릭터 설정 변경
   * @param {String} gid - Game Service ID
   * @param {String} worldId - 게임 내 월드 식별자
   * @param {String} worldName - 게임 내 월드 이름
   * @param {String} gcid - 게임 내 캐릭터 식별자
   * @param {String} gcName - 게임 내 캐릭터 이름
   * @param {String} gcClass - 게임 내 캐릭터 직업
   */
  updateCharacter: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'updateCharacter',
      {
        method: 'put',
        url: `/user/character/${store.getters['main/shopSeq']}`,
        data: {
          shopSeq: store.getters['main/shopSeq'],
          gid: params.gid,
          worldId: params.worldId,
          worldName: params.worldName,
          gcid: params.gcid,
          gcName: params.gcName,
          gcLevel: params.gcLevel,
          gcClass: params.gcClass
        }
      },
      successCallback,
      errorCallback
    )
  }
}

export default CharacterAPI
